// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.ConfirmDeleteAvatarModal_inner__1VGzi {\n  text-align: center;\n  width: 430px;\n  max-width: 100%;\n  padding: 0 12px;\n  margin: 0 auto; }\n  .ConfirmDeleteAvatarModal_inner__1VGzi img {\n    max-width: 228px;\n    max-height: 228px;\n    border-radius: 50%;\n    margin-bottom: 24px; }\n  .ConfirmDeleteAvatarModal_inner__1VGzi p {\n    margin-bottom: 0;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px; }\n\n.ConfirmDeleteAvatarModal_modalWrapper__1Nr-f .ant-modal-body {\n  padding: 40px 40px 48px 40px; }\n", ""]);
// Exports
exports.locals = {
	"inner": "ConfirmDeleteAvatarModal_inner__1VGzi",
	"modalWrapper": "ConfirmDeleteAvatarModal_modalWrapper__1Nr-f"
};
module.exports = exports;
